import { App, URLOpenListenerEvent } from '@capacitor/app'
import VueRouter, { isNavigationFailure, NavigationFailureType } from 'vue-router'
import { getRoomIdFromUniversalLink } from './nativeRoomLink'
import { getRoomLocation } from './roomLink'

let pendingRoomId: string | undefined

const openUniversalRoomLink = async (router: VueRouter, url: string) => {
  const roomId = getRoomIdFromUniversalLink(url)
  if (!roomId) return false
  if (pendingRoomId === roomId) return true

  const currentRoomId = router.currentRoute.params.roomId
  if (currentRoomId === roomId && ['room', 'game'].includes(router.currentRoute.name || '')) return true

  pendingRoomId = roomId
  try {
    await router.push(getRoomLocation(roomId))
  } catch (error) {
    if (!isNavigationFailure(error, NavigationFailureType.duplicated)) throw error
  } finally {
    if (pendingRoomId === roomId) pendingRoomId = undefined
  }

  return true
}

const registerNativeDeepLinks = async (router: VueRouter) => {
  let openedRoomLink = false
  const handleUrl = ({ url }: URLOpenListenerEvent) => {
    if (getRoomIdFromUniversalLink(url)) openedRoomLink = true
    void openUniversalRoomLink(router, url).catch(() => undefined)
  }

  await App.addListener('appUrlOpen', handleUrl)

  const launch = await App.getLaunchUrl()
  if (launch?.url) openedRoomLink = await openUniversalRoomLink(router, launch.url) || openedRoomLink

  return openedRoomLink
}

export { openUniversalRoomLink, registerNativeDeepLinks }
